module.exports = "/_next/static/images/KernLogo-35b8c5fea021e4730ff939dde887ae79.png";